document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('scroll', function() {
    const footerContent = document.querySelector('footer .footer-content');
    const footerContact = document.querySelector('footer #contact');

    if (footerContact && footerContent) {
      const rectContent = footerContent.getBoundingClientRect();
      const windowHeightContent = window.innerHeight;

      if (rectContent.top < windowHeightContent && rectContent.bottom > 0) {
        const scale = Math.min(1, Math.max(0.7, 0.7 + (rectContent.top / windowHeightContent) * 0.3));
        footerContact.style.transform = `scale(${scale})`; 
      } else {
        footerContact.style.transform = 'scale(1)'; 
      }

      const opacity = Math.min(1, Math.max(0, (windowHeightContent - rectContent.top) / windowHeightContent) * 2);
      footerContent.style.opacity = opacity; 

      const paddingTop = Math.min(40, Math.max(0, (windowHeightContent - rectContent.top) / 5));
      footerContent.style.paddingTop = `${paddingTop}px`;
    }
  });
  
  
  if (window.innerWidth < 992) {
    const accordionHeaders = document.querySelectorAll('.footer-content__column-title');

    accordionHeaders.forEach(header => {
      header.addEventListener('click', () => {
        header.classList.toggle('active');
        const linksContainer = header.nextElementSibling;

        linksContainer.classList.toggle('active');
      });
    });
  } 
});
